import Vue from 'vue'
import App from './App.vue'
import VCalendar from 'v-calendar';
Vue.use(VCalendar)

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css' // Vuesax
Vue.use(Vuesax)

// dayjs
import * as dayjs from 'dayjs'
Vue.prototype.$dayjs = dayjs;

// axios
import axios from './axios.js'
Vue.prototype.$http = axios

// Theme Configurations
import '../themeConfig.js'

// ACL
import acl from './acl/acl'


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import '@/assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'


// Vue Router
import router from './router/index.js'


// Vuex Store
import store from './store/store'


// i18n
import i18n from './i18n/i18n'

import VueClipboard from 'vue-clipboard2'



// VeeValidate
import VeeValidate from 'vee-validate'
Vue.use(VeeValidate)
// Google Maps
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
  load: {
    // Add your API key here
    key: 'AIzaSyBPIRV-wtiCRjHKE4LdiXsBxaDZLnLWpjI',
    libraries: 'places' // This is required if you use the Auto complete plug-in
  }
})
VueClipboard.config.autoSetContainer = true // add this line
Vue.use(VueClipboard)
// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)

import VuePlaceAutocomplete from 'vue-place-autocomplete';

Vue.use(VuePlaceAutocomplete);
import VueGoogleAutocomplete from 'vue-google-autocomplete';

Vue.use(VueGoogleAutocomplete, {
  apiKey: 'AIzaSyBPIRV-wtiCRjHKE4LdiXsBxaDZLnLWpjI',
});
// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'


// Feather font icon
require('./assets/css/iconfont.css')


// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';


Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  acl,
  render: h => h(App)
}).$mount('#app')
